import {AbstractCommand} from "./abstract.command";
import {CommandName} from "./command-name.enum";
import {TenantThemeContent} from "./payloads/tenant-theme-content";

/**
 * Saves the tenant's theme stylesheet (feature plan 0054). Mirrors the backend `save.tenant-theme`
 * command. Like the translation override it has no entity, so `mainEntityClass` is the synthetic
 * marker `'tenant-theme'` and `mainEntityUid` the tenant.
 *
 * No transformer (ADR-016): the payload is a `CommandPayload`, serialized by the generic path in
 * `TransformerHelper`. Do not add a `save-tenant-theme-command-to-dto.transformer.ts` — an
 * architecture test refuses it.
 */
export class SaveTenantThemeCommand extends AbstractCommand<TenantThemeContent> {

    public name: CommandName = CommandName.SAVE_TENANT_THEME;

    public tags = ['tenant-theme', 'save'];

    constructor(tenant: string, content: TenantThemeContent) {
        super('tenant-theme', tenant, content);
    }

}
